module.exports = __webpack_public_path__ + "static/media/1012259.686fdd81.jpg";